import { Sale } from "@towersystems/roam-common/lib/generated-types";
import { createContext } from "react";

export type SaleContextType = {
  sale: Sale;
};

export const SaleContext = createContext<SaleContextType | undefined>(
  undefined
);
